<template src="@/templates/bookings/bookingTokenInfo.html"></template>

<script>
import BookingDetailModel from "@/models/bookingDetailModel";
import { mapActions } from "vuex";

export default {
  name: "BookingTokenInfo",
  props: ["token"],
  data() {
    return {
      description: "",
      menuLink: "",
      show: "",
    };
  },
  created() {
    console.log("booking detail : " + this.token);

    if (this.token) {
      this.checkToken();
      return;
    }

    this.getInformation();
  },
  methods: {
    ...mapActions(["updateHideAll"]),
    checkToken() {
      if (!this.token) {
        return;
      }

      let data = {
        token: this.token,
      };

      let bookingDetailModel = new BookingDetailModel();

      bookingDetailModel
        .checkToken(data)
        .then((res) => {
          if (res) {
            this.updateHideAll();
            let result = res.response.data;

            if (result.error) {
              if (result.error == "Expired token") {
                this.getInformation("expiredToken");
                return;
              }
            }

            /**if token is validated, render the job detail view*/
            if (result.job_id > 0 && result.interpreter_id != "") {
              let fmInterpreterId = localStorage
                .getItem("fmInterpreterId")
                .toLowerCase();
              if (fmInterpreterId == result.interpreter_id.toLowerCase()) {
                if (result.job_taken_by == "" || result.job_taken_by == null) {
                  if (result.job_rejected == true) {
                    this.getInformation("jobRejected");
                    return;
                  }

                  /**Open the job detail page for booking*/
                  console.log("fine here");
                  this.$router.push({
                    path:
                      "/bookingdetail/" + result.job_id + "/BookingAvailable",
                  });
                  return;
                }

                if (result.job_taken_by.toLowerCase() != fmInterpreterId) {
                  this.getInformation("takenByOther");
                  return;
                }
                this.getInformation("bookedAlready");
                return;
              } else {
                this.getInformation("invalidToken");
                return;
              }
            } else {
              this.getInformation("invalidToken");
              return;
            }
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.response.status == "401") {
              Event.$emit("tokenExpiredLogout");
              return;
            }
          }
          debugger;
        });
    },
    getInformation(status) {
      this.show = true;
      switch (status) {
        case "jobRejected":
          this.description =
            "You have declined this booking previously. To view available bookings, please go to menu:";
          this.menuLink = "Bookings -> Available";
          break;
        case "takenByOther":
          this.description =
            "This job has been taken by other Interpreter. To view available bookings, please go to menu:";
          this.menuLink = "Bookings -> Available";
          break;
        case "bookedAlready":
          this.description =
            "You have already accepted this job. To view confirmed bookings, please go to menu:";
          this.menuLink = "Bookings -> Current Confirmed";
          break;
        case "invalidToken":
          this.description =
            "You do not have access to this booking. To view available bookings, please go to menu:";
          this.menuLink = "Bookings -> Available";
          break;
        case "expiredToken":
          this.description =
            "Booking token has expired. To view available bookings, please go to menu:";
          this.menuLink = "Bookings -> Available";
          break;
        default:
          this.description =
            "Oops! Something went wrong. To view available bookings, please go to menu:";
          this.menuLink = "Bookings -> Available";
          break;
      }
    },
  },
};
</script>

<style scoped></style>
